import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import PaymentBrandSalesOfficeAccountingAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-brands/payment-brand-sales-office-accounting/payment-brand-sales-office-accounting.entity";
import { PayloadAccountSalesMulti } from "../../account-sales/interfaces/account-sales.interface";

const apiUrl = env.API_PAYMENT_MASTER_URL;
const moduleName = "payment_brand_sales_office_accounting";

@Injectable({
  providedIn: "root",
})
export class PaymentBrandSalesOfficeService extends AbstractService<
    PaymentBrandSalesOfficeAccountingAttributes,
    PayloadAccountSalesMulti,
    PayloadAccountSalesMulti> {

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    getAllList(paymentTypeId: string, paymentBrandId: string): Observable<IAPIListResult<PaymentBrandSalesOfficeAccountingAttributes>> {
        const API_URL: string = apiUrl + `api/${moduleName}/${paymentTypeId}/${paymentBrandId}`;
        return this.http.get<IAPIListResult<PaymentBrandSalesOfficeAccountingAttributes>>(API_URL);
    }
}
